import { useState } from "react";
import { gossipFaqs } from "@/mocks/gossipList";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 border-y border-background-200" aria-labelledby="faq-title">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          <div className="lg:col-span-1">
            <p className="flex items-center gap-2 text-xs text-accent-700 mb-2">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-question-line"></i>
              </span>
              FAQ
            </p>
            <h2 id="faq-title" className="font-heading font-black text-2xl md:text-3xl text-foreground-950">
              常见问题
            </h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              关于这 30 条是怎么筛的、状态标签怎么读、以及能不能投稿，
              这些都整理在下面。没找到答案就去联系我们。
            </p>
          </div>

          <div className="lg:col-span-2">
            <dl className="space-y-3">
              {gossipFaqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div
                    key={faq.question}
                    className={`bg-background-50 border rounded-lg overflow-hidden transition-colors ${
                      isOpen ? "border-primary-300" : "border-background-200"
                    }`}
                  >
                    <dt>
                      <button
                        type="button"
                        aria-expanded={isOpen}
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 cursor-pointer"
                      >
                        <span className="font-heading font-bold text-sm md:text-base text-foreground-950">
                          {faq.question}
                        </span>
                        <span
                          className={`w-6 h-6 shrink-0 flex items-center justify-center rounded-full transition-colors ${
                            isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                          }`}
                        >
                          <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                        </span>
                      </button>
                    </dt>
                    {isOpen && (
                      <dd className="px-5 pb-5 -mt-1 text-sm text-foreground-600 leading-relaxed">{faq.answer}</dd>
                    )}
                  </div>
                );
              })}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}